var favourites = ( function( $ ) {

	var $favourite_button;

	var _init = function() {
		$favourite_button = $( '.favourite-button' );

		$favourite_button.on( 'click', _update_is_favourite );
	};

	var _update_is_favourite = function( e ) {
		e.preventDefault();

		var $this     = $( this );
		var type      = $this.attr( 'data-type' );
		var course_id = $this.attr( 'data-course' );

		if ( $this.hasClass( 'error' ) ) {
			return;
		}

		$this.loading();

		var data = {
			type: type,
			course_id: course_id,
			action: 'crate_update_is_favourite',
			nonce: ScriptData.crate_update_is_favourite_nonce
		};

		$.post( ScriptData.ajaxurl, data, _update_is_favourite_response );
	};

	var _update_is_favourite_response = function( response ) {
		if ( response.success ) {
			$favourite_button.each( function( index ) {
				var $button = $( $favourite_button[ index ] );

				if ( $button.attr( 'data-course' ) == response.course_id ) {
					$button.loaded();
					$button.text( response.button_text );
					$button.attr( 'data-type', response.type === 'remove' ? 'add' : 'remove' );
					$button.removeClass( 'error' );

					if ( response.type === 'remove' ) {
						$button.removeClass( 'added' );
					} else {
						$button.addClass( 'added' );
					}
				}
			} );
		} else {
			console.log( 'Error', response.errors );

			$favourite_button.each( function( index ) {
				var $button = $( $favourite_button[ index ] );

				if ( $button.attr( 'data-course-id' ) == response.course_id ) {
					$button.loaded();
					$button.text( 'There has been an error. Please refresh and try again' );
					$button.addClass( 'error' );
				}
			} );
		}
	};

	if ( $( '.favourite-button' ).length > 0 ) {
		$( document ).ready( _init );
	}

	return {};

} )( jQuery );

module.exports = favourites;